import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
// import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded'
import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import BlockIcon from "@mui/icons-material/Block";
import ImageIcon from "@mui/icons-material/Image";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
// import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded'
import { Button } from "@themesberg/react-bootstrap";
import Tooltip from "@mui/material/Tooltip";

const ActionMenu = (props) => {
	const {
		handleShow,
		isHidden,
		isActive,
		parentId,
		name,
		handleStatusShow,
		handlePopular,
		handleNewGame,
		casinoGamesData,
		casinoGameId,
		casinoPopularId,
		indx,
		handleDeleteItems,
		navigate,
		setCasinoGame,
		casinoBonus,
		isPopular,
		newGame,
		handleActive,
		setSelectedCasinoGameId,
		setCasinoBonusModal,
		handleThumbnailModalOpen,
		setPopularModal,
		setIsOpenAssignCategoryModal
	} = props;
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			{!isHidden({ module: { key: "CasinoManagement", value: "U" } }) ||
				!isHidden({ module: { key: "CasinoManagement", value: "T" } }) ? (
				<>
					<Button
						variant="btn text-btn"
						id="basic-button"
						aria-controls={open ? "basic-menu" : undefined}
						aria-haspopup="true"
						aria-expanded={open ? "true" : undefined}
						onClick={handleClick}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "right",
						}}
						transformOrigin={{
							vertical: "top",
							horizontal: "right",
						}}
					>
						<MoreVertRoundedIcon />
					</Button>
					<Menu
						id="basic-menu"
						anchorEl={anchorEl}
						open={open}
						onClose={handleClose}
						MenuListProps={{
							"aria-labelledby": "basic-button",
						}}
					>
						{!isHidden({ module: { key: "CasinoManagement", value: "U" } }) ? <MenuItem onClick={handleClose}>
							<Button
								variant="btn text-btn"
								onClick={() => {
									setPopularModal({
										isOpen: true,
										isPopular: isPopular,
										casinoPopularId: casinoPopularId,
										from: "casino_page",
										name: casinoBonus?.name

									})
								}}
							>
								{!isPopular ? (
									<>
										<CheckCircleRoundedIcon />
										<span className="text">Set Trending</span>
									</>
								) : (
									<>
										<CancelRoundedIcon />
										<span className="text">Remove Trending</span>
									</>
								)}
							</Button>
						</MenuItem> : ""}

						{!isHidden({ module: { key: "CasinoManagement", value: "T" } }) ? <MenuItem onClick={handleClose}>
							<Button
								variant="btn text-btn"

								onClick={() =>
									handleActive({
										data: {
											casinoGameId: casinoPopularId,
											code: "CASINO_GAME",
											status: !isActive,
										},
									})
								}
							>
								{isActive ? (
									<>
										<CancelRoundedIcon />
										<span className="text">Remove Active</span>
									</>
								) : (
									<>
										<CheckCircleRoundedIcon />
										<span className="text">Set Active</span>
									</>
								)}
							</Button>
						</MenuItem> : ""}
						{!isHidden({ module: { key: "CasinoManagement", value: "U" } }) ?  <MenuItem onClick={handleClose}>
							<Button
								variant="btn text-btn"
								onClick={() =>
									handleNewGame({
										data: { casinoPopularId },
										newKey: newGame,
										from: "casino_page",
									})
								}
							>
								{!newGame ? (
									<>
										<CheckCircleRoundedIcon />
										<span className="text">Set New Game</span>
									</>
								) : (
									<>
										<CancelRoundedIcon />
										<span className="text">Remove New Game</span>
									</>
								)}
							</Button>
						</MenuItem> : ""}

						{!isHidden({ module: { key: "CasinoManagement", value: "U" } }) ? <MenuItem onClick={handleClose}>
							<Button
								variant="btn text-btn"
								onClick={() => {
									setSelectedCasinoGameId(casinoGameId);
									setCasinoBonusModal(true);
									setCasinoGame(casinoBonus);
								}}
							>
								<>
									<CheckCircleRoundedIcon />
									<span className="text">Add Bonus</span>
								</>
							</Button>
						</MenuItem> : ""}

						{!isHidden({ module: { key: "CasinoManagement", value: "U" } }) ? <MenuItem
							onClick={() => {
								handleClose();
								handleThumbnailModalOpen();
							}}
						>
							<Button variant="btn text-btn">
								<>
									<ImageIcon />
									<span className="text">Update Thumbnail URL</span>
								</>
							</Button>
						</MenuItem> : ""}

						{!isHidden({ module: { key: "CasinoManagement", value: "U" } }) && <MenuItem onClick={handleClose}>
							<Tooltip
								title={!isActive ? "Activate the game to add it to a category" : ""}
								arrow
							>
								<span>
									<Button
										variant="btn text-btn"

										disabled={!isActive}
										onClick={() => {

											setIsOpenAssignCategoryModal({ isOpen: true, selectedData: { id: casinoGameId, } })

										}}
									>
										<>
											<CheckCircleRoundedIcon />
											<span className="text">Add to category</span>
										</>
									</Button>
								</span>
							</Tooltip>
						</MenuItem>}

						
						{/* <MenuItem onClick={handleClose}>
                    <Button
                        variant='btn text-btn'
                        disabled={parentId?false:true}
                        hidden={isHidden({
                            module: {
                            key: 'CasinoManagement',
                            value: 'U',
                            },
                        })}
                        onClick={() => handleDeleteItems(casinoGameId)}
                        >
                        <DeleteForeverOutlinedIcon />
                        <span className='text'>Delete</span>
                    </Button>
                </MenuItem> */}
						{/* <MenuItem onClick={handleClose}>
                    <Button
                       variant='btn text-btn'
                        hidden={isHidden({ module: { key: 'CasinoManagement', value: 'U' } })}
                        onClick={() => navigate(`/admin/casino-games/restrict-countries/${casinoGameId}`)}
                    >
                        <BlockIcon />
                        <span className='text'>View Blocked Countries</span>
                    </Button>
                </MenuItem> */}
					</Menu>
				</>
			) : (
				"NA"
			)}
		</>
	);
};

export default ActionMenu;
